import React from 'react';
import { Grid, CardMedia, Link } from '@mui/material';
import { PageHelmet } from './PageHelmet';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { useTranslation } from '@stateManagement/TranslationContext';
import { getTranslation } from '@helpers/languageTranslations';
import { getLanguageUrlPrefixByCode } from '@helpers/languages';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { PublicSearchBar } from '@components/PublicSearch/PublicSearchBar';
import { linkStyles, breakpoints, colors } from '@web-for-marketing/react-ui';
import { Heading, Text } from '@web-for-marketing/react-ui';
import notFound from '@images/404_Image.svg';
import { SectionContainer } from '@components/SectionComponents/SectionContainer';

const classes = {
    center: {
        textAlign: 'center',
    },
    minorSpacing: {
        marginBottom: '3rem',

        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: '2rem',
        },
    },
    description: {
        fontWeight: 700,
        color: colors.core.blackTarr,
    },
    image: {
        marginBottom: '-10rem',
        maxWidth: '1100px',

        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: '-5rem',
        },
    },
    searchContainer: {
        maxWidth: '60rem !important',
        width: '100%',
    },
    homeLink: linkStyles.endOfLine,
} as const;

export function ErrorPage(): React.ReactElement {
    const [selectedLanguage] = useAtom(selectedLanguageAtom);
    const { prefixStringWithBaseUrl } = useStaticValues();
    const { selectedLanguageTranslation } = useTranslation();
    const errorPageTranslation = getTranslation(selectedLanguageTranslation, 'notFound');

    return (
        <>
            <PageHelmet seo={{ title: errorPageTranslation.title }} />
            <SectionContainer>
                <Grid container css={classes.center} alignItems='center' justifyContent='center' direction='column'>
                    <Grid css={classes.minorSpacing}>
                        <Heading variant='h1' color='primary'>
                            {errorPageTranslation.heading}
                        </Heading>
                    </Grid>
                    <Grid css={classes.minorSpacing}>
                        <Text variant='body1' css={classes.description}>
                            {errorPageTranslation.description}
                        </Text>
                        <Text variant='body1' css={classes.description}>
                            {errorPageTranslation.description2}
                            <Link href={getLanguageUrlPrefixByCode(selectedLanguage)} css={classes.homeLink}>
                                {errorPageTranslation.homepageLink}
                            </Link>
                            .
                        </Text>
                    </Grid>
                    <Grid css={classes.searchContainer}>
                        <PublicSearchBar />
                    </Grid>
                </Grid>
                <Grid container alignItems='center' justifyContent='center' direction='column'>
                    <CardMedia
                        image={prefixStringWithBaseUrl(notFound)}
                        alt='An illustration of a blue person holding a telescope looking out into the distance on top of a mountain.'
                        component='img'
                        css={classes.image}
                    />
                </Grid>
            </SectionContainer>
        </>
    );
}
